module.exports = __webpack_public_path__ + "static/media/JuriSaatMelakukanPenilaian.0f9ec564.WebP";